import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Events from './pages/Events';
import EventTemplate from './pages/EventTemplate';
import Careers from './pages/Careers';
import Team from './pages/Team';
import TeamMember from './pages/TeamMember';
import Contact from './pages/Contact';
import ArticleOfTheWeek from './pages/ArticleOfTheWeek';
import ArticleTemplate from './pages/ArticleTemplate';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventTemplate />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/team" element={<Team />} />
            <Route path="/team/:memberId" element={<TeamMember />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/article-of-the-week" element={<ArticleOfTheWeek />} />
            <Route path="/article/:slug" element={<ArticleTemplate />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={
              <ProtectedRoute requiredRole="member">
                <Dashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;
